import React from "react";
import * as conf from "@qpr/client-api-base/configuration";
import Search from "components/Search";
import Breadcrumb from "components/toolbars/Breadcrumb";
import { getFileApiURL } from "@qpr/client-api-base/utils/url-utils";
import { ICardElementWithChildren } from "backend/model/model";
import {
  getCurrentGlobalContext,
  useAppContext,
} from "@qpr/client-api-base/context/AppCtxProvider";
import * as registry from "@qpr/client-api-registry";

import { ReactComponent as PaperPlusIcon } from "assets/PaperPlus.svg";
import { ReactComponent as CloseButton } from "assets/Close.svg";
import { ReactComponent as Delete } from "assets/Delete.svg";
import { ReactComponent as AttachmentPinIcon } from "assets/AttachmentPinIcon.svg";
import { ReactComponent as PdfIcon } from "assets/Pdf.svg";
conf.System.query.enableChildCache = true;
conf.System.query.enableObjectCache = true;

conf.setMapQueryResults((row: ICardElementWithChildren) => {
  if (row.typename === "KPI") {
    row.rangecolor = row.rangecolor_PERF_YTD_OPEN || "000000";
    row.rangename = row.rangename_PERF_YTD_OPEN;
    row.rangevalue = row.rangevalue_PERF_YTD_OPEN;
  }

  if (row.typename === "Organization") {
    row.rangecolor = row.rangecolor_PERF_W_YTD || "000000";
    row.rangename = row.rangename_PERF_W_YTD;
    row.rangevalue = row.rangevalue_PERF_W_YTD;
  }

  /*
  if (row.typename === "Organization") {
    row.rangecolor = row.rangecolor_PERF_YTD_OPEN || "000000";
    row.rangename = row.rangename_PERF_YTD_OPEN;
    row.rangevalue = row.rangevalue_PERF_YTD_OPEN;
  }
  */

  // Strategic Objective

  if (row.typename.toLowerCase().includes("objective")) {
    row.rangecolor = row.rangecolor_PERF_AVG_YTD || "000000";
    row.rangename = row.rangename_PERF_AVG_YTD;
    row.rangevalue = row.rangevalue_PERF_AVG_YTD;
  }
  return row;
});

const periodDate = new Date();
periodDate.setDate(0); // last date of previous month
conf.setDefaults(
  "defaultPeriod",
  `${(periodDate.getUTCMonth() + 1).toString()} / ${periodDate
    .getFullYear()
    .toString()}`
);
conf.setDefaults("models", ["v0.5"]);
conf.setDefaults("defaultModel", "v0.5");

registry.addSvg({
  AttachmentPinIcon,
  PdfIcon,
  PaperPlusIcon,
  Delete,
  CloseButton,
});

conf.setIcon(
  "NotificationIcon",
  <img
    src={getFileApiURL("/icons/NotificationCenter.svg")}
    alt="Notifications"
  />
);
conf.setToolbar("SearchBar", Search);
conf.setToolbar("Breadcrumb", Breadcrumb);
const LanguageSwitch = () => {
  const ctx = useAppContext();
  return (
    <button
      onClick={() => {
        ctx.sendValue("rtl", !ctx.rtl);
      }}
    >
      {ctx.rtl ? "RTL" : "LTR"}
    </button>
  );
};

conf.setToolbar("PlanSwitch", () => <div />);

// <LanguageSwitch />
conf.setToolbar("SearchBar", () => (
  <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap" }}>
    <Search />
  </div>
));

// defines how the status flag status is handled

// conf.System.draftValuesHandling.isDraftStatus = (value) => value === "0";

conf.System.draftValuesHandling.isDraftStatus = (value) => false;

conf.setDraftDisabledPages(["workflowinput", "completedtasks"]);

conf.setDraftFilteredSeries((typename: string) => {
  return [];
});
